export enum PlatformType {
    windows = 'windows',
    mac = 'mac',
    unix = 'unix',
    linux = 'linux',
    ipad = 'ipad',
    iphone = 'iphone',
    ipod = 'ipod',
    android = 'android',
    unknown = 'unknown',
}

export enum DeviceFormFactor {
    phone = 'phone',
    tablet = 'tablet',
    desktop = 'desktop',
}

export enum OperatingSystem {
    windows = 'windows',
    iOS = 'iOS',
    macOS = 'macOS',
    android = 'android',
    other = 'other',
}

export enum MilanoteApplicationMode {
    desktop = 'desktop',
    mobile = 'mobile',
}

export enum BrowserEngineType {
    safari = 'safari',
    chrome = 'chrome',
    firefox = 'firefox',
    edge = 'edge',
    androidChrome = 'android-chrome',
    iosSafari = 'ios-safari',
    unknown = 'unknown',
}

export enum ApplicationType {
    web = 'web',
    iframe = 'iframe',
    windowsPwa = 'windows-pwa',
    macPwa = 'mac-pwa',
    electronMac = 'electron-mac',
    iphoneCapacitor = 'iphone-capacitor',
    iphoneSwift = 'iphone-swift',
    iphonePwa = 'iphone-pwa',
    androidCapacitor = 'android-capacitor',
    androidTabletCapacitor = 'android-tablet-capacitor',
    androidFlutter = 'android-flutter',
    androidPhonePwa = 'android-phone-pwa',
    androidTabletPwa = 'android-tablet-pwa',
    ipadCapacitor = 'ipad-capacitor',
    ipadSwift = 'ipad-swift',
    ipadPwa = 'ipad-pwa',
}

export enum ApplicationPlatform {
    // Old platform descriptions - keeping for checking existing data - do not use for new data
    WEB_DEPRECATED = 'WEB',
    PWA_DEPRECATED = 'PWA',
    MAC_DESKTOP_APP_DEPRECATED = 'MAC_DESKTOP_APP',
    IPAD_DEPRECATED = 'iPad',
    IPHONE_DEPRECATED = 'IPHONE',
    ANDROID_DEPRECATED = 'ANDROID',
    IPHONE_SHARE_EXTENSION = 'IPHONE_SHARE_EXTENSION',

    // Apps
    iphoneApp = 'iPhone app',
    ipadApp = 'iPad app',
    androidPhoneApp = 'Android phone app',
    androidTabletApp = 'Android tablet app',
    macAppElectron = 'Mac app (electron)',

    // PWAs
    windowsPwa = 'Windows PWA',
    macPwa = 'Mac PWA',
    iphonePwa = 'iPhone PWA',
    ipadPwa = 'iPad PWA',
    androidPhonePwa = 'Android phone PWA',
    androidTabletPwa = 'Android tablet PWA',

    // Web
    desktopWeb = 'Desktop web',
    iphoneWeb = 'iPhone web',
    ipadWeb = 'iPad web',
    androidPhoneWeb = 'Android phone web',
    androidTabletWeb = 'Android tablet web',

    // Version conflicts will have a platform of 'conflict' so they can be distinguished from others
    conflict = 'CONFLICT',

    none = 'none',
}

export type PlatformDetails = {
    appType: ApplicationType;
    appMode: MilanoteApplicationMode;
    type: PlatformType;
    formFactor: DeviceFormFactor;
    os: OperatingSystem;
    applicationPlatform: ApplicationPlatform;
    capacitorPlatform: string;
    userAgent: string;
    browserEngine: BrowserEngineType;
    appVersion: string | null;
    appBuild: string | null;
    initialScreenWidth: number;
    initialScreenHeight: number;
    initialDevicePixelRatio: number;
    screenOrientation: OrientationType;
    features: {
        isTouch: boolean;
        isRetina: boolean;
        supportsMouse: boolean;
        supportsWebSockets: boolean;
        supportsWorker: boolean;
        supportsSvg: boolean;
        supportsContentEditable: boolean;
        supportsLocalStorage: boolean;
        supportsIndexedDb: boolean;
        supportsServiceWorker: boolean;
    };
};

export const PLATFORM_DETAILS_UPDATE = 'PLATFORM_DETAILS_UPDATE';

export type PlatformDetailsUpdateAction = {
    type: typeof PLATFORM_DETAILS_UPDATE;
    details: Partial<PlatformDetails>;
};
